module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture9-d1c0b51078ae71e1cb3d384638af3a55.jpg";